import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import PreviewButton from '../PreviewButton';
import TaskInformation from '../TaskInformation';
import ValidationButton from '../ValidationButton';
import axios from 'axios';
import { getTask } from '../../../store/action/taskAction';
import { getClaimDetails } from "../../../store/action/claim";
import { getPartyDetails } from '../../../store/action/party';
import { makeStyles } from '@material-ui/core/styles';
import PDFViewer from './PDFViewer';
import { completeTask } from "../../../store/action/taskAction";
import {useNavigate, useParams} from "react-router-dom";
import * as Actions from "../../../store/action/claimManagement";
import ErrorsAlert from "../../../utils/errorsAlert";
const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: "100vh",
        width: '100%',
        position: 'relative',
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
        padding: '20px',
        width: '100%',
        marginTop: '20px',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    },
}));

const CarExitVoucher = () => {
    const { taskId } = useParams();
    const classes = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const username = localStorage.getItem('username');
    const taskReducer = useSelector((state) => state.taskReducer.taskList.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer);
    const [infoSinistre, setInfoSinistre] = useState(task?.businessKey)
    const [serviceProposals, setServiceProposals] = useState([]);
    const [claimDetails, setClaimDetails] = useState(null);
    const [partyDetails, setPartyDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errors, setErrors] = useState([]);

    const handleClose = () => {
        setOpenErrorDialog(false);
        setErrors([]);
    };

     const fetchClaimAssociatedData = async () => {
       try {
         const claimServiceProposals = await dispatch(Actions.getClaimServiceProposals(claimDetails?.claimNumber)); 
         setServiceProposals(claimServiceProposals); 
       } catch (error) {
         console.log(error.message || 'An error occurred while fetching data');
       }
     };
   
     useEffect(() => {
       if (claimDetails?.claimNumber) {
         fetchClaimAssociatedData();
       }
     }, [claimDetails]);
    const fetchCarExitVoucher = async () => {
        if (claimDetails) {
            setLoading(true);
            try {
                // Extracting and formatting data from claimDetails and partyDetails
                const clientName = `${partyDetails?.name} ${partyDetails?.lastName}`;
                const clientAddress = partyDetails?.partyAddresses?.length > 0 
                    ? partyDetails.partyAddresses
                        .filter((address) => address.addressType === "RESIDENTIAL")
                        .map((address) => {
                            const addr = address.address;
                            const street = addr?.street || 'Unknown street';
                            const number = addr?.number || 'N/A';
                            const city = addr?.city || 'Unknown city';
                            const postalCode = addr?.postalCode?.postalCode || 'Unknown postal code';
                            const state = addr?.state?.label || 'Unknown state';

                            return `${number} ${street}, ${city}, ${state} ${postalCode}`;
                        })[0]
                    : 'Client Address';

                const requestData = {
                    claimDate: new Date(claimDetails?.occurrenceDate).toLocaleDateString(),
                    claimNumber: claimDetails?.claimNumber,
                    licencePlate: claimDetails?.involvedCars?.find(car => car?.role === 'INSURED_CAR')?.goodUid || 'N/A',
                    clientName,
                    clientAddress,
                    claimTotalAmount: claimDetails?.claimAmount?.toFixed(2),
                    serviceAcceptanceDate: new Date().toLocaleDateString(),
                    claimAmountLetter: `${claimDetails?.claimAmount} Dinars`,
                    customerPaymentPart: serviceProposals[0]?.customerPayment?.toFixed(2),
                };

                const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL_MS_COMMUNICATIONCHANNELS}/api/document/generate/CAR_EXIT_VOUCHER`, requestData, {
                    responseType: 'blob',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });

                const pdfBlobUrl = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                setPdfUrl(pdfBlobUrl);
            } catch (error) {
                console.error('Error fetching PDF:', error);
            } finally {
                setLoading(false);
            }
        }
    };


    const fetchClaimDetails = async () => {
        setLoading(true);
        try {
            const claim = await dispatch(getClaimDetails(infoSinistre));
            setClaimDetails(claim);

            // Find the InsuredDriver in involvedParties
            const insuredDriver = claim?.involvedParties.find(party => party?.role === 'InsuredDriver');
            if (insuredDriver) {
                const driverDetails = await getPartyDetails(insuredDriver?.partyUid);
                setPartyDetails(driverDetails);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const ValidationAction = async () => {
        if (loading) {
            setErrors(["Veuillez patienter pendant le chargement des données"]);
            setOpenErrorDialog(true);
            return;
        }

        const validationErrors = [];

        if (!pdfUrl) {
            validationErrors.push("Le bon de sortie n'a pas pu être généré. Veuillez réessayer.");
        }

        if (!claimDetails) {
            validationErrors.push("Les détails du sinistre n'ont pas pu être chargés.");
        }

        if (!partyDetails) {
            validationErrors.push("Les informations du client n'ont pas pu être chargées.");
        }

        if (!serviceProposals || serviceProposals.length === 0) {
            validationErrors.push("Les propositions de service n'ont pas pu être chargées.");
        }

        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setOpenErrorDialog(true);
            return;
        }

        try {
            await dispatch(completeTask(taskId, username, {}));
            navigate('/todo-list', { reload: true });
        } catch (error) {
            console.error(error);
            setErrors(["Erreur lors de la validation. Veuillez réessayer."]);
            setOpenErrorDialog(true);
        }
    }


    useEffect(() => {
        const fetchTask = async () => {
            try {
                const response = await getTask(taskId, username);
                setTask(response)
                setInfoSinistre(response?.businessKey)
            } catch (error) {
                console.error(`Error fetching task details: ${error.message}`);
            }
        };
        fetchTask();
    }, [dispatch, taskId, username]);


    useEffect(() => {
        if (task?.assignee === username) {
            setIsTaskClaimed(false);
        } else {
            setIsTaskClaimed(true);
        }
    }, [task, username]);

   

    useEffect(() => {
       

        if (infoSinistre) {
            fetchClaimDetails();
        }
    }, [dispatch, infoSinistre]);
    
    useEffect(() => {
        

        fetchCarExitVoucher();
    }, [claimDetails, partyDetails]);

    return (
        <div className={classes.root}>
            <div style={{display: 'flex'}}>
            <div className={classes.mainContent}>
                <TaskInformation taskId={taskId} onClaimStatusChange={setIsTaskClaimed} />
                <Paper className={classes.paper}>
                    <PDFViewer
                        documentName="Prévisualiser votre bon de sortie"
                        pdfUrl={pdfUrl}
                        loading={loading}
                    />
                </Paper>
            </div>
            <PreviewButton claimData={infoSinistre}  />
        </div>
            <ValidationButton taskId={taskId} handleValidation={() => isTaskClaimed ? null : ValidationAction()} />
            <ErrorsAlert
                open={openErrorDialog}
                errors={errors}
                handleClose={handleClose}
            />
        </div>
    );
};

export default CarExitVoucher;
